import { render, staticRenderFns } from "./TMResultsSummaryV2.vue?vue&type=template&id=17edfde7&scoped=true"
import script from "./TMResultsSummaryV2.vue?vue&type=script&lang=js"
export * from "./TMResultsSummaryV2.vue?vue&type=script&lang=js"
import style0 from "./TMResultsSummaryV2.vue?vue&type=style&index=0&id=17edfde7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17edfde7",
  null
  
)

export default component.exports